import React from 'react';
import AccountDetail_Comp from '../../Components/AccountDetail/AccountDetail';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function AccountDetail() {
  return (
    <>
    <Dashboard_Comp>
    <AccountDetail_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default AccountDetail;